import ProductTourContent from 'src/components/ProductTourContent';
import { IProductTour } from 'src/models/productTour';

export const ComparisonStep: IProductTour = {
  title: 'How to Use Comparison',
  menu: 'social-media',
  submenu: 'comparison',
  steps: [
    {
      title: "Let's Get Started With The Comparison!",
      content: (
        <ProductTourContent spacing={1}>
          Comparison allows you to compare brands by comparing objects, groups
          of objects, or labels.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Start the Tour'
    },
    {
      title: 'Open Comparison Menu',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Click here to open the comparison menu.
        </ProductTourContent>
      )
    },
    {
      title: 'Create New Comparison',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Click here to select the data source you want to compare.
        </ProductTourContent>
      )
    },
    {
      title: 'Select a Data Source to Compare',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          You can select objects, labels, or groups to compare. For now, choose
          'Objects'.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Select to Compare',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Select items to compare. Everything you choose will be added to the
          comparison panel, with each item displayed as its own comparison
          group.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Add Name',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Type your comparison title here.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Customize Your Comparison Groups',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Each item is now added as its own comparison group. You can customize
          each group, add sources, rename groups, and edit the comparison name
          as needed
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Customize Your Comparison Groups',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Enter the group name, and you can customize the color by clicking the
          color icon.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Customize Your Comparison Groups',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Add objects in each group for comparison.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Select Objects',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Select any objects you want to include in your comparison group, then
          click Done.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Add Group',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          You can add more groups to compare.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'The Final Step',
      content: (
        <ProductTourContent spacing={2}>
          All steps are complete. You've successfully finished this stage and
          are now ready to continue exploring and using all available features.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Finish'
    }
  ]
};
